import React, { CSSProperties, FC, HTMLAttributes } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SpacingPropsType } from 'types/Layout';
import { cssTheme } from '../../../../themes';
import { getLinariaClassName } from '../../../../utils/getLinariaClassName';
interface StyleProps {
  rowGap?: string;
  columnGap?: string;
}
interface FlexProps extends HTMLAttributes<HTMLDivElement> {
  alignItems?: CSSProperties['alignItems'];
  justifyContent?: CSSProperties['justifyContent'];
  wrap?: CSSProperties['flexWrap'];
  flexDirection?: CSSProperties['flexDirection'];
  gap?: SpacingPropsType;
  isReversed?: boolean;
  style?: React.CSSProperties;
  className?: string;
  componentRef?: React.Ref<HTMLDivElement>;
}
const _exp = /*#__PURE__*/() => ({
  rowGap
}) => rowGap ?? 0;
const _exp2 = /*#__PURE__*/() => ({
  columnGap
}) => columnGap ?? 0;
const BaseElement = /*#__PURE__*/styled('div')({
  name: "BaseElement",
  class: "bgw6ny8",
  propsAsIs: false,
  vars: {
    "bgw6ny8-0": [_exp()],
    "bgw6ny8-1": [_exp2()]
  }
});
const FlexColumn: FC<FlexProps> = ({
  children,
  style,
  className,
  alignItems = 'stretch',
  justifyContent = 'flex-start',
  wrap = 'nowrap',
  gap = 's000',
  isReversed = false,
  componentRef,
  ...rest
}) => <BaseElement rowGap={cssTheme.layout.spacing[gap]} style={style} className={cx(`${getLinariaClassName(BaseElement)}-ai-${alignItems}`, `${getLinariaClassName(BaseElement)}-jc-${justifyContent}`, `${getLinariaClassName(BaseElement)}-fw-${wrap}`, `${getLinariaClassName(BaseElement)}-fd-${isReversed ? 'column-reverse' : 'column'}`, className)} ref={componentRef} {...rest}>
    {children}
  </BaseElement>;
export const FlexRow: FC<FlexProps> = ({
  children,
  style,
  className,
  alignItems = 'stretch',
  justifyContent = 'flex-start',
  wrap = 'nowrap',
  gap = 's000',
  isReversed = false,
  componentRef,
  ...rest
}) => <BaseElement columnGap={cssTheme.layout.spacing[gap]} style={style} className={cx(`${getLinariaClassName(BaseElement)}-ai-${alignItems}`, `${getLinariaClassName(BaseElement)}-jc-${justifyContent}`, `${getLinariaClassName(BaseElement)}-fw-${wrap}`, `${getLinariaClassName(BaseElement)}-fd-${isReversed ? 'row-reverse' : 'row'}`, className)} ref={componentRef} {...rest}>
    {children}
  </BaseElement>;
export const Flex = {
  Row: FlexRow,
  Column: FlexColumn
};
export const FlexComponent: FC<FlexProps> = ({
  children
}) => <>{children}</>;

require("./Flex.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Flex.tsx");